import React, { useState, useEffect } from 'react';
import { db } from '../firebase/firebaseconfig';
import { collection, addDoc, getDocs, deleteDoc, doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { UserPlus, Trash2, Building2, ListOrdered, Edit3, Check, X } from 'lucide-react';
import AdminSidebar from './adminsidebar';

const AdminAddClient = () => {
  const [clientName, setClientName] = useState('');
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  // --- EDIT STATES ---
  const [editId, setEditId] = useState(null);
  const [editValue, setEditValue] = useState('');

  // Fetch existing clients
  const fetchClients = async () => {
    setLoading(true);
    try {
      const querySnapshot = await getDocs(collection(db, "clients"));
      const clientData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setClients(clientData);
    } catch (error) {
      console.error("Error fetching clients:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchClients();
  }, []);

  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!clientName.trim()) return;

    try {
      await addDoc(collection(db, "clients"), {
        name: clientName.trim(),
        createdAt: serverTimestamp()
      });
      setClientName('');
      alert("Client added successfully!");
      fetchClients(); 
    } catch (error) {
      console.error("Error adding client:", error);
    }
  };

  // --- EDIT LOGIC ---
  const startEdit = (client) => {
    setEditId(client.id);
    setEditValue(client.name);
  };

  const cancelEdit = () => {
    setEditId(null);
    setEditValue('');
  };

  const handleUpdate = async (id) => {
    if (!editValue.trim()) return;
    try {
      const clientRef = doc(db, "clients", id);
      await updateDoc(clientRef, { name: editValue.trim() });
      setEditId(null);
      fetchClients();
    } catch (error) {
      console.error("Error updating client:", error);
    }
  };

  // Handle Delete Client
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this client?")) {
      await deleteDoc(doc(db, "clients", id));
      fetchClients();
    }
  };

  return (
    
        <div className="container-fluid">
          <div className=" ">
      <div className="row g-4">
        
        {/* Left Side: Add Client Form */}
        <div className="col-lg-4">
          <div className="card border-0 shadow-sm rounded-4 p-4">
            <h4 className="fw-bold mb-4 text-success d-flex align-items-center">
              <UserPlus className="me-2" size={22} /> New Client
            </h4>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="small text-muted mb-1 ms-1">Official Company Name</label>
                <div className="input-group">
                  <span className="input-group-text bg-light border-0">
                    <Building2 size={16} className="text-muted"/>
                  </span>
                  <input 
                    type="text" 
                    className="form-control bg-light border-0" 
                    placeholder="e.g. Reliance BP Mobility Ltd"
                    value={clientName}
                    onChange={(e) => setClientName(e.target.value)}
                    required 
                  />
                </div>
              </div>
              <button type="submit" className="btn btn-success w-100 py-2 fw-bold rounded-3 shadow-sm">
                SAVE CLIENT
              </button>
            </form>
          </div>
        </div>

        {/* Right Side: Client Table */}
        <div className="col-lg-8">
          <div className="card border-0 shadow-sm rounded-4 p-4">
            <h4 className="fw-bold mb-4 d-flex align-items-center">
              <ListOrdered className="me-2 text-primary" size={22} /> Registered Clients
            </h4>
            
            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead className="table-light">
                  <tr>
                    <th className="border-0 small text-uppercase text-muted">Client Name</th>
                    <th className="border-0 small text-uppercase text-muted text-end pe-4">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="2" className="text-center py-4">Loading clients...</td></tr>
                  ) : clients.length === 0 ? (
                    <tr><td colSpan="2" className="text-center py-4">No clients registered yet.</td></tr>
                  ) : (
                    clients.map((client) => (
                      <tr key={client.id}>
                        <td>
                          {editId === client.id ? (
                            <input 
                              type="text" 
                              className="form-control form-control-sm border-success"
                              value={editValue}
                              onChange={(e) => setEditValue(e.target.value)}
                              autoFocus
                            />
                          ) : (
                            <span className="fw-bold text-dark">{client.name}</span>
                          )}
                        </td>
                        <td className="text-end pe-3">
                          {editId === client.id ? (
                            <>
                              <button 
                                className="btn btn-sm btn-success me-2 rounded-circle" 
                                onClick={() => handleUpdate(client.id)}
                              >
                                <Check size={16} />
                              </button>
                              <button 
                                className="btn btn-sm btn-secondary rounded-circle" 
                                onClick={cancelEdit}
                              >
                                <X size={16} />
                              </button>
                            </>
                          ) : (
                            <>
                              <button 
                                className="btn btn-sm text-primary me-2 border-0 bg-transparent" 
                                onClick={() => startEdit(client)}
                                title="Edit Client"
                              >
                                <Edit3 size={16} />
                              </button>
                              <button 
                                className="btn btn-sm text-danger border-0 bg-transparent" 
                                onClick={() => handleDelete(client.id)}
                                title="Delete Client"
                              >
                                <Trash2 size={16} />
                              </button>
                            </>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
        </div>
     




   
  );
};

export default AdminAddClient;